const joinPath = (...segments) => {
    return segments
        .filter(Boolean)
        .map((segment) => String(segment))
        .join('/')
        .replace(/([^:]\/)\/+/g, '$1');
};

module.exports = function () {
    const args = Array.prototype.slice.call(arguments, 0, arguments.length - 1);
    const first = args.find(Boolean);
    if (first && String(first).includes('://')) return joinPath(...args);

    return joinPath(process.env.CLOUD_FRONT_BASE_URL || '', ...args);
};
